import { Outlet } from 'react-router-dom';
import { ComponentPropsWithoutRef } from 'react';
import { SkipLinks } from 'components/SkipLinks';
import { WormholeExit } from 'components/Wormhole';
import { SignupHeader } from '../SignupHeader/SignupHeader';

type Props = {
  children?: React.ReactNode;
} & ComponentPropsWithoutRef<typeof SignupHeader>;

export const SignupLayout = ({ children = <Outlet />, ...rest }: Props): JSX.Element => {
  return (
    <>
      <SkipLinks />
      <SignupHeader {...rest} />
      <WormholeExit loc="header" />
      <main id="maincontent" tabIndex={-1} className="flex flex-col flex-grow bg-cream-50 max-w-[100vw]">
        {children}
      </main>
    </>
  );
};
